module.exports = __webpack_public_path__ + "static/security2@3x-7d645b6a04b7dc258bb39a1bd6586302.png";